import { allThemes, Box, ColorOptions, Icon, Text } from '@jfs/ui-new'
import { FC } from 'react'
import styles from './styles'

// interface StepData {
//   state: string // { complete, current, next}
//   text: string
// }

interface StepProgressProps {
  stepData?: any
  totalStepsCovered?: Number
}

const labelWithDefinition = (item, index, totalStepsCovered) => {
  const stepsFinished = totalStepsCovered >= index + 1
  const getTextStyles = () => {
    const value = totalStepsCovered > index + 1 ? 'complete' : totalStepsCovered === index + 1 ? 'current' : 'next'
    const getStyles = {
      complete: { ...styles.labelText },
      current: { ...styles.currentLabel },
      next: { ...styles.labelTextLight },
    }
    return getStyles[value]
  }
  return (
    <Box {...styles.contentWrapper}>
      {stepsFinished ? (
        <Box {...styles.roundedCircleFilled}>
          {totalStepsCovered !== index + 1 ? (
            <Icon id="SUCCESSFUL_FILLED" size={24} color={allThemes.light.colors.GREEN as ColorOptions} />
          ) : (
            <Icon id="RADIOBUTTON_ON" size={24} color={allThemes.light.colors.PRIMARY as ColorOptions} />
          )}
        </Box>
      ) : (
        <Box {...styles.roundedCircle} />
      )}
      <Box {...styles.textWrapper}>
        <Text {...getTextStyles()}>{item?.label}</Text>
      </Box>
    </Box>
  )
}

const StepProgressIndicator: FC<StepProgressProps> = ({ stepData, totalStepsCovered }) => {
  return (
    <Box {...styles.container}>
      {stepData.map((item, index) => {
        const stepsFinished = totalStepsCovered > index + 1
        const color = stepsFinished
          ? (allThemes.light.colors.GREEN as ColorOptions)
          : (allThemes.light.colors.VERY_LIGHT_GREY as ColorOptions)
        return (
          <>
            {labelWithDefinition(item, index, totalStepsCovered)}
            {index + 1! !== stepData.length && <Box {...styles.separator} backgroundColor={color} />}
          </>
        )
      })}
    </Box>
  )
}

export { StepProgressIndicator }
